
  import { Vue, Component, Prop } from "vue-property-decorator";
  import moment from "moment";
  import SourcesMultiselect from "@/components/autocompleteMultiselects/SourcesMultiselect.vue";
  import TagMultiselect from "@/components/autocompleteMultiselects/TagMultiselect.vue";
  import { Tag, Source } from "@/generated/graphql";
  import CREATE_RESOURCEINFO_CARD from "@/apollo/contractors/CreateResourceInformationCard.gql"
  import Checkbox from "@/components/form/Checkbox.vue";
  import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import FormDatepicker from "@/components/form/FormDatepickerNew.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import FormTextarea from "@/components/form/FormTextarea.vue";
  import FormGroup from "@/components/form/FormGroupNew.vue";
  import FormInputGroup from "@/components/form/FormInputGroup.vue";
  import CrossIcon from "@/components/icons/CrossIconNew.vue";
  import ActivityDataForModal from "@/entities/modals/ActivityDataForModal";
  import { Contractor, Project } from "@/interface"; 
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";
  import ModalContent from "@/components/modal/ModalContent.vue";

  enum ValidationMsg {
    PROJECT_START = "contractor start date",
    PROJECT_END = "contractor end date",
  }

  interface ContractorDetails {
    contractor: Contractor;
    activeProjectsCount: number;
    completedProjectsCount: number;
   }

  @Component({
    components: {
      ModalContent,
      CrossIcon,
      ModalFullScreen,
      DropdownFilter,
      FormDatepicker,
      UiButton,
      FormTextarea,
      FormGroup,
      FormInputGroup,
      SourcesMultiselect, 
      Checkbox,
      TagMultiselect,
    },

    })
  export default class AddResourceInformationModal extends Vue {
    @Prop({ type: Object, default: undefined }) readonly project?: Project;
    @Prop({ type: Object, default: null }) readonly projectActivity!: ActivityDataForModal | null;
    @Prop({ type: String, default: null }) readonly currentUserRole!: string;
    @Prop({ type: Object, default: undefined }) readonly appliedTag?: Tag;
    @Prop({ type: Object, default: undefined }) readonly appliedSource?: Source;
    @Prop({ type: String, default: null }) readonly companyId!: string;
    @Prop({ type: Boolean, default: false }) readonly isEdittingLocked!: boolean;
    @Prop({ type: String, required: true}) readonly currentUserId!: string;
    @Prop({type: String, required: true }) readonly contractorId!: string;

    show: boolean =false;
    contractor: Contractor[] = [];
    contractorDetails?: ContractorDetails;
    selectedTagId: string | null = null;
    selectedSourceId: string | null = null;
    processing: boolean =false;
    contractor_id: string | null = null
    user_id: string | null = null

    UpdateResourceInformation = {
      tag_id:"",
      startDate: "",
      endDate: "",
      rate: "",
      notes: "",
      profileLink: "",
      selectedSourceId: [],
      available:true
    };

    source= {
        id: "",
        name:""
      }

      tag= {
        id: "",
        name:""
      }

    showAvailabilityCheckbox = {
      name: "Availability",
      id: "available",
      selected: true,
    }
    get queryArgs(): Object {
        return {
            id: this.contractorId,
        };
    }

    get appliedTagId(): string | undefined {
      return this.appliedTag?.id;
    } 
    get appliedSourceId(): string | undefined {
      return this.appliedSource?.id;
    }
    get modalTitle(): string {
      return `${this.modalPurpose} Resource Information`;
    }
    get possibleEndDate(): Date | undefined {
      return moment("dddd, MMMM Dd YYYY").add(30, 'd').toDate();
    }
    get possibleStartDate(): Date | undefined {
      return moment("dddd, MMMM Dd YYYY").add(1, 'd').toDate();
    }
    get withContractor(): boolean {
      return Boolean(this.contractorId);
    }

    get modalPurpose(): string {
      return this.projectActivity?.id ? "Edit" : "Create";
    }

    get buttonText(): string {
      return  !this.projectActivity?.isNew
        ? "Update"
        : "Create";
    }

    closeModal(): void {
      this.$emit("close");
    }
    saveClick(): void {
      this.$emit("close");
    }
    setSourceId(sourceId: string): void {
      this.selectedSourceId = sourceId.length === 0 ? null : sourceId;
    }
    setTagId(tagId: string): void {
      this.selectedTagId = tagId.length === 0 ? null : tagId;
    }

    get startDateValidationRules(): string | object {
      //@ts-ignore
      const { from_date, to_date } = this.contractor;
      const noBeforeProjectStart = `noBefore:${from_date},${ValidationMsg.PROJECT_START}`;
      const noAfterProjectEnd = `noAfter:${to_date},${ValidationMsg.PROJECT_END}`;
      return `${noBeforeProjectStart}|${noAfterProjectEnd}|required_field`;
    }

    async onAdd(): Promise<void> {    
      if (!this.contractorId) {
        return;
      }
      try { 
          this.processing = true;
          await this.$apollo.mutate({
            mutation: CREATE_RESOURCEINFO_CARD,
            variables: { 
                notes: this.UpdateResourceInformation.notes,
                rate: this.UpdateResourceInformation.rate,
                from_date: this.UpdateResourceInformation.startDate,
                to_date: this.UpdateResourceInformation.endDate,
                availability: this.showAvailabilityCheckbox.selected,
                profile_link: this.UpdateResourceInformation.profileLink,
                tag_id: this.selectedTagId,
                source_id: this.selectedSourceId,
                contractor_id: this.contractorId,
                user_id: this.currentUserId
          }
          });
        this.$emit('add')
        this.$emit('refresh')
        this.$eventBus.emit(
          NOTIFICATION,
          Message.successMessage("Information added successfully")
        );
      } catch(err) {
        this.$eventBus.emit(
          NOTIFICATION,
          Message.errorMessage(err.message)
        );
      } finally {
        this.processing = false
        this.closeModal()
      }
    }
 

    
  }
